// English source strings of the shared composer (decision D36, docs/delivery/composer-and-simplicity-plan.md sections A
// and B): attachments, dictation, slash commands, the counter, and the Home chat controls (project, agent, integrations,
// mode). Merged into `en`; pt-BR lives in pt-BR-composer.ts (complete, checked by the type).
export const enComposer = {
  "composer.attach": "Attach files",
  "composer.attachHint": "Up to 5 files of 10 MB: images and screenshots (PNG, JPEG, WebP, GIF, BMP, TIFF, AVIF, HEIC, SVG), PDF, Word, Excel, text, code, Markdown, JSON, CSV or logs. Drop or paste them here too.",
  "composer.dropHere": "Drop files to attach them",
  "composer.attachments": "Attachments",
  "composer.remove": "Remove {name}",
  "composer.uploading": "Uploading…",
  "composer.uploadFailed": "Upload failed: {reason}",
  "composer.chipLabel": "{name}, {size}, {type}",
  "composer.kind.text": "Text",
  "composer.kind.image": "Image",
  "composer.kind.pdf": "PDF",
  "composer.reject.type": "{name}: this file type is not accepted.",
  "composer.reject.size": "{name}: larger than 10 MB.",
  "composer.reject.empty": "{name} is empty.",
  "composer.reject.count": "At most {max} files per message.",
  "composer.pastedName": "pasted-text-{n}.txt",
  "composer.pastedNote": "The long text you pasted was attached as {name}.",
  "composer.attachmentsOnly": "Please look at the attached file(s).",
  "composer.waitUploads": "Wait for the attachments to finish uploading.",
  "composer.readAttachments": "Files sent with the question",

  "composer.mic.start": "Dictate",
  "composer.mic.stop": "Stop dictation",
  "composer.mic.listening": "Listening… speak, then review the text and send it.",
  "composer.mic.unavailable": "Dictation is not available in this browser.",
  "composer.mic.failed": "Dictation stopped: the microphone is unavailable or permission was denied.",

  "composer.slash.menu": "Commands",
  "composer.slash.clear": "Start a new conversation",
  "composer.slash.help": "List the commands",
  "composer.slash.status": "Status of the project or the system",
  "composer.slash.validate": "Validate the project's readiness",
  "composer.slash.task": "Create a task",
  "composer.slash.plan": "Make a plan",
  "composer.slash.fix": "Fix a problem",
  "composer.slash.publish": "Publish the project",
  "composer.slash.logs": "Recent failures and their logs",
  "composer.slash.guardian": "Server Guardian status and incidents",
  "composer.slash.mcp": "Integrations and tools available",
  "composer.slash.agent": "Pick an agent",
  "composer.slash.mode": "Pick a mode",
  "composer.slash.homeOnly": "Choose the agent and the mode in the Home chat.",
  "composer.help.title": "Commands",
  "composer.help.unknown": "Any other text starting with / is sent as a message.",
  "composer.panel.close": "Close",
  "composer.newConversation": "New conversation. The previous one stays in the history of the server.",

  "composer.mcp.title": "Integrations and tools",
  "composer.mcp.loading": "Loading the integrations…",
  "composer.mcp.empty": "No active integration in this organization.",
  "composer.mcp.forbidden": "Only organization maintainers and admins can list the integrations.",
  "composer.mcp.failed": "Could not load the integrations.",
  "composer.mcp.tools": "Tools: {list}",

  "composer.prompt.status": "What is the current status? Summarize what is running, what is blocked and what is waiting for me.",
  "composer.prompt.validate": "Validate the readiness of this project and tell me what is missing.",
  "composer.prompt.publish": "Publish this project.",
  "composer.prompt.logs": "Show me the recent failures and their logs.",
  "composer.prompt.guardian": "What does the Server Guardian report? List the open incidents and the proposed fixes.",
  "composer.prompt.task": "Create a task: {text}",
  "composer.prompt.plan": "Make a plan for: {text}",
  "composer.prompt.fix": "Fix this problem: {text}",
  "composer.prefill.task": "Create a task: ",
  "composer.prefill.plan": "Make a plan for: ",
  "composer.prefill.fix": "Fix this problem: ",

  "composer.home.controls": "Chat options",
  "composer.home.project": "Project",
  "composer.home.projectAll": "All projects",
  "composer.home.projectNew": "New project…",
  "composer.home.agent": "Agent",
  "composer.home.agentDefault": "Default assistant",
  "composer.home.integrations": "Integrations",
  "composer.home.integrationsCount": "Integrations ({n})",
  "composer.home.integrationsHint": "The selected integrations are sent as context hints.",
  "composer.home.mode": "Mode",
  "composer.mode.chat": "Talk",
  "composer.mode.plan": "Plan",
  "composer.mode.assisted": "Assisted development",
  "composer.mode.autonomous": "Free development",
  "composer.modeHint.chat": "Answers only: nothing is changed.",
  "composer.modeHint.plan": "Produces a plan or PRD and tasks: nothing runs.",
  "composer.modeHint.assisted": "Every change waits for your confirmation.",
  "composer.modeHint.autonomous": "Automatic actions run; sensitive ones still ask for confirmation.",

  // D36.4: every image and file in the composer, Home "Build" attachments, thumbnails and translated API errors.
  "composer.kind.document": "Document",
  "composer.thumbnail": "Preview of {name}",
  "home.attachFiles": "Attach a PRD, screenshots or files",
  "home.attachFilesHint": "A Markdown, TXT, PDF or DOCX document becomes the PRD; images and other files go to the planner with the brief.",
  "home.planningWithAttachments": "{n} attached file(s) went to the planner with the brief.",
  "apiError.detail": "Technical detail: {detail}",
  "apiError.cause.attachment_type": "This file type is not accepted. Attach images (PNG, JPEG, WebP, GIF, BMP, TIFF, AVIF, HEIC, SVG), PDF, Word or Excel files, or text, code, Markdown, JSON, CSV and log files.",
  "apiError.cause.attachment_content": "The file's content does not match its type: it may be damaged or renamed.",
  "apiError.cause.attachment_empty": "The file is empty.",
  "apiError.cause.attachment_too_large": "The file is larger than 10 MB.",
  "apiError.cause.attachment_name": "The file has no name.",
  "apiError.cause.attachment_not_found": "An attachment is no longer available. Attach it again.",
  "apiError.cause.attachment_scope": "An attachment belongs to another project. Attach it again here.",
  "apiError.cause.turn_active": "The assistant is still answering the previous question. Wait for it or stop it.",
  "apiError.tooLarge": "The file is larger than 10 MB.",
  "apiError.code.bad_request": "The request could not be understood. Check the information and try again.",
  "apiError.code.unauthenticated": "Your session has expired. Sign in again.",
  "apiError.code.mfa_required": "Confirm your two-factor code to continue.",
  "apiError.code.forbidden": "You do not have permission to do this.",
  "apiError.code.not_found": "Not found: it may have been removed, or you no longer have access to it.",
  "apiError.code.version_conflict": "This was changed in the meantime. Reload and try again.",
  "apiError.code.idempotency_conflict": "This request was already sent with different content. Reload and try again.",
  "apiError.code.invalid_requirement": "The request has an invalid requirement.",
  "apiError.code.validation_failed": "Some information is invalid. Check it and try again.",
  "apiError.code.gate_pending": "A required step is still pending.",
  "apiError.code.policy_denied": "A policy blocks this action.",
  "apiError.code.rate_limited": "Too many requests. Wait a moment and try again.",
  "apiError.code.unavailable": "The service is unavailable right now. Try again in a moment.",
  "apiError.code.internal": "Something went wrong on the server. Try again; if it persists, share the correlation id.",
  "apiError.code.unknown": "The request failed. Try again.",
} as const;
